var exports = {
  "B": "AuthCardContainer.module__inertOverlay___QmJtWV",
};

module.exports = exports;
